import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { environment } from './environment';

/**
 * Firebase = the SHARED IDENTITY project (meshtek-auth-{env}, auth IA
 * §14). The SPA authenticates against it and talks to Detect's API with
 * the resulting ID token. There is NO Firestore client here: Detect's
 * rules are deny-all, and every read goes through the API.
 */
let app: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = initializeApp({
      apiKey: environment.auth.apiKey,
      authDomain: environment.auth.authDomain,
      projectId: environment.auth.projectId,
      appId: environment.auth.appId,
    });
  }
  return app;
}

export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}
